import { createContext } from "react";

type ResetSearchContext = {
  resetSearch: boolean;
  triggerSearchReset: () => void;
};

export const ResetSearchContext = createContext<ResetSearchContext>({
  resetSearch: false,
  triggerSearchReset: () => undefined
});
